import React from 'react';
import Login from './login';
import { Route, Routes } from 'react-router';
import Register from './Register';


const App = () => {
  return (
    <Routes>
      <Route path='/' element={<Login/>}/>
      <Route path='/Register' element={<Register/>}/>
    </Routes>
    
  );
}

export default App;
